import { ldClientId, ldClientProdId } from '@/lib/constants/launchDarkly';
import { getCurrentEnv, getLDQueryParams } from '@/lib/utils/utils';

const currentEnv = getCurrentEnv();
const location = getLDQueryParams();
const userKey = Math.random().toString(20).substring(2, 6);

export const ldConfig = {
  clientSideId: currentEnv === 'PROD' || currentEnv === 'CSR' ? ldClientProdId : ldClientId,
  user: {
    key: userKey
  },
  context: {
    kind: 'user',
    key: userKey,
    location
  }
};
